module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/banners/gift-card-bg-89bf4c726a7edf59f3e382f6b9408f16.svg";